import { Trans } from '@lingui/macro'
import {
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField
} from '@mui/material'
import { useDispatch } from 'react-redux'
import DebouncedTextField from '../../common/DebouncedTextField'
import Checkbox from 'app/views/common-components/CustomCheckbox'

export const FormEditorSubmitButton = ({
  typeProps = {},
  depth,
  editMode,
  injectable,
  disabled,
  ...props
}) => {
  const dispatch = useDispatch()
  const {
    showPrintPromptAfterSubmit,
    displayFormErrors,
    errorListTitle
  } = typeProps

  if (!editMode) {
    return (
      <Button color="primary" variant="contained" fullWidth>
        <Trans>Submit</Trans>
      </Button>
    )
  }

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(showPrintPromptAfterSubmit)}
            disabled={disabled}
            onChange={(e) => {
              const toSet = { ...typeProps }
              toSet.showPrintPromptAfterSubmit = e.target.checked
              dispatch({
                type: 'FIELD',
                injectable,
                depth: depth.split('.'),
                fieldName: 'typeProps',
                fieldValue: toSet,
              })
            }}
          />
        }
        label={<Trans>Show print prompt after submit</Trans>}
      />
      <Grid item xs style={{ padding: 5 }}>
        <Grid container wrap="nowrap">
          <TextField
            select
            fullWidth
            variant="outlined"
            label={<Trans>FORM_SUBMIT_BUTTON_SHOULD_DISPLAY_ERRORS</Trans>}
            value={displayFormErrors ?? true}
            onChange={(e) => {
              const toSet = { ...typeProps }
              delete toSet.displayFormErrors
              toSet.displayFormErrors = e.target.value
              dispatch({
                type: 'FIELD',
                injectable,
                depth: depth.split('.'),
                fieldName: 'typeProps',
                fieldValue: toSet,
              })
            }}
          >
              <MenuItem value={true}>
                <Trans>FORM_SUBMIT_BUTTON_DISPLAY_ERRORS</Trans>
              </MenuItem>
              <MenuItem value={false}>
                <Trans>FORM_SUBMIT_BUTTON_NO_ERROR_LIST</Trans>
              </MenuItem>
          </TextField>
        </Grid>
        <DebouncedTextField
          value={errorListTitle || ''}
          style={{ marginTop: 15, marginBottom: 5 }}
          fullWidth
          label={<Trans>FORM_EDITOR_FIELD_ERRORS_LIST_HEADER</Trans>}
          variant='outlined'
          multiline
          onChange={(e) => {
            const toSet = { ...typeProps }
            toSet.errorListTitle = e.target.value
            if (!e.target.value) {
              delete toSet.errorListTitle
            }
            dispatch({
              type: 'FIELD',
              injectable,
              depth: depth.split('.'),
              fieldName: 'typeProps',
              fieldValue: { ...toSet }
            })
          }}
        />
      </Grid>
    </div>
  )
}
